import chatStyle from '../Skeletons/Skeletons.module.css'

const ChatSkeleton = ({count}) => {
    return (
      <div className={chatStyle.chatScreenBubble }>
        {[...Array(count)].map((_, index) => (
          <div
            key={index}
            className={index % 2 !== 0 ? chatStyle.sentLoadingBubble : chatStyle.receivedLoadingBubble}
          ></div>
        ))}
      </div>
    );
  };

  
  export default ChatSkeleton